import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, List, ListItem, ListItemText, ListSubheader } from '@mui/material';
import { HashLink } from 'react-router-hash-link';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export interface IUnsatisfiedSection {
  sectionAlias: string;
  sectionLabel: string;
  questions: IUnsatisfiedQuestion[];
}

export interface IUnsatisfiedQuestion {
  questionAlias: string;
  questionLabel: string;
}

export default function SectionsValidationModal({
  unsatisfiedSections,
  open,
  onClose,
}: {
  unsatisfiedSections: IUnsatisfiedSection[];
  open: boolean;
  onClose: () => void;
}) {
  const getQuestionUrl = (sectionAlias: string, questionAlias: string) => {
    const newPath = location.pathname.split('/').slice(0, -1).join('/') + '/' + sectionAlias;
    const hash = questionAlias ? `#${questionAlias}` : '';
    return `${newPath}${hash}`;
  };

  const renderList = () => {
    const groups = unsatisfiedSections.filter((u) => u.questions?.length);
    return groups.map(renderSection);
  };

  const renderSection = (section: IUnsatisfiedSection) => {
    const { questions, sectionLabel, sectionAlias } = section || {};

    return (
      <List
        key={sectionAlias}
        sx={{ bgcolor: 'background.paper' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            {sectionLabel}
          </ListSubheader>
        }
      >
        {questions.map((q) => {
          return (
            <ListItem key={q.questionAlias} sx={{ pl: 4, pt: 0, pb: 0 }}>
              <ListItemText>
                {/* @ts-ignore */}
                <HashLink smooth to={getQuestionUrl(sectionAlias, q.questionAlias)}>
                  {q.questionLabel}
                </HashLink>
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
    );
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="SmartGovernanceValidationModal"
        aria-describedby="SmartGovernanceValidationModal"
      >
        <Box sx={style}>
          <Typography sx={{ mb: 3, fontWeight: 'bold' }} variant="h6" component="h2">
            Validation Error
          </Typography>
          <Alert severity="error">The following fields are mandatory</Alert>
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
          <div style={{ width: '100%', maxHeight: 500, overflowY: 'scroll' }}>{renderList()}</div>
        </Box>
      </Modal>
    </div>
  );
}
